<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-08-14 10:59:57
 * @LastEditors: yd
 * @LastEditTime: 2020-11-28 16:08:40
-->
<template>
  <div>
    <div class="d-flex"
         v-if="!readonly"
         style="width:100%">
      <div style="width:178px">
        <mrc_ess_prompt :label="$t('label_The_area_code') + label"
                        :rules="false"
                        :chips="false"
                        v-model="codes"
                        :errMsg="codeErrMsg"
                        @getData="change"
                        obj="country_mobile_prefix">
        </mrc_ess_prompt>
      </div>
      <div style="flex-grow:1">
        <mrc_ess_input v-model.number="phones"
                       @input="input"
                       :error-messages="errorMessages"
                       :readonly="false"
                       :label="$t('label_The_phone') + label"
                       :isNational="judegNational(phone)">
        </mrc_ess_input>
      </div>
    </div>
    <div style="width:100%"
         v-else>
      <mrc_ess_input v-model="codePhone"
                     :readonly="true"
                     :label="$t('label_The_phone') + label">
      </mrc_ess_input>
    </div>
  </div>
</template>

<script>
//区号 电话组件
//  :changeCode.sync="父组件传过来的code属性值"  父组件必写
export default {
  components: {},
  props: {
    label: {
      type: String,
      default: '*',
    },
    codeErrMsg: {},
    errorMessages: {
      type: Array,
      default: () => [],
    },
    code: {
      type: [String, Number],
      default: '',
    },
    phone: {
      type: [Number, String],
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'phone',
    event: 'changePhone',
  },
  data () {
    return {
      codes: '',
      phones: '',
    }
  },
  computed: {
    codePhone () {
      if (!this.codes && !this.phones) return null
      return '+' + this.codes + '\xa0\xa0' + String(this.phones)
    },
  },
  created () { },
  watch: {
    code (v) {
      this.codes = Number(v)
    },
    phone (v) {
      this.phones = v
    },
  },
  mounted () {
    this.codes = Number(this.code)
    this.phones = this.phone
  },

  methods: {
    change (v) {
      this.$emit('update:changeCode', v)
    },
    input (v) {
      this.$emit('changePhone', v)
    },
  },
}
</script>

<style scoped></style>
